import OrderCargoOrderNodeExclusionRequest from "../../../../api/raily/order/cargo-order/node-exclusion/order-cargo-order-node-exclusion.request";
import OrderCargoOrderNodeExclusionParams from "./order-cargo-order-node-exclusion-params";

const create = (
  params: OrderCargoOrderNodeExclusionParams,
): OrderCargoOrderNodeExclusionRequest => {
  return {
    orderUuid: params.orderUuid,
  };
};

const orderCargoOrderNodeExclusionParamsFactory = {
  create,
};

export default orderCargoOrderNodeExclusionParamsFactory;
